import { FC, ReactNode, CSSProperties } from "react";

interface CardProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  variant?: "default" | "elevated" | "outlined" | "filled";
  padding?: "none" | "sm" | "md" | "lg" | "xl";
  rounded?: "none" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl";
  shadow?: "none" | "sm" | "md" | "lg" | "xl";
  background?: string;
  onClick?: () => void;
}

export const Card: FC<CardProps> = ({ 
  children, 
  className = "",
  style,
  variant = "default",
  padding = "md",
  rounded = "lg",
  shadow = "none",
  background,
  onClick
}) => {
  // Variant styles
  const variantClasses = {
    default: "bg-white",
    elevated: "bg-white shadow-md",
    outlined: "bg-white border border-gray-200",
    filled: "bg-gray-50"
  };

  // Padding classes
  const paddingClasses = {
    none: "p-0",
    sm: "p-2",
    md: "p-4",
    lg: "p-6",
    xl: "p-8"
  };

  // Rounded classes
  const roundedClasses = {
    none: "rounded-none",
    sm: "rounded-sm",
    md: "rounded-md",
    lg: "rounded-lg",
    xl: "rounded-xl",
    "2xl": "rounded-2xl",
    "3xl": "rounded-3xl"
  };

  // Shadow classes
  const shadowClasses = {
    none: "",
    sm: "shadow-sm",
    md: "shadow-md",
    lg: "shadow-lg",
    xl: "shadow-xl"
  };

  const baseClasses = "relative transition-all duration-200 overflow-scrollbar-hidden";
  const interactiveClass = onClick ? "cursor-pointer hover:shadow-lg" : "";

  return (
    <div 
      className={`
        ${baseClasses}
        ${variantClasses[variant]}
        ${paddingClasses[padding]}
        ${roundedClasses[rounded]}
        ${shadowClasses[shadow]}
        ${interactiveClass}
        ${className}
      `}
      style={{ backgroundColor: background, ...style }}
      onClick={onClick}
    >
      {children}
    </div>
  );
};